import PropTypes from "prop-types";
import React from "react";

import AddRouteForm from "v2/components/responsive/AddRouteForm";
import ModalLink from "v2/components/responsive/ModalLink";

const AddRouteLink = (props, context) => {
  const {params: {date}} = context;
  return (
    <ModalLink
      form={AddRouteForm}
      icon="plus-circle"
      label="New Route"
      linkClassName="erg-add-link"
      url={`/${date}/new`}
      {...props} />
  );
};

AddRouteLink.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
  }),
};

export default AddRouteLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/AddRouteLink.js
 **/